/**
 * M.2 — NIPE tool: openVaultNote
 *
 * Read-only. Reads the full markdown body of a single vault note.
 */

import type { NipeTool } from './types';

export interface OpenVaultNoteContext {
  openVaultNote: (
    path: string,
  ) => Promise<{ path: string; body: string } | null>;
}

export const openVaultNoteTool: NipeTool<OpenVaultNoteContext> = {
  schema: {
    type: 'function',
    function: {
      name: 'openVaultNote',
      description:
        'Read the full markdown body of a single vault note by its path.',
      parameters: {
        type: 'object',
        properties: {
          path: {
            type: 'string',
            description:
              'Vault-relative path, e.g. "Cases/Hadley v. Baxendale.md".',
          },
        },
        required: ['path'],
      },
    },
  },
  mutatesRemote: false,
  requiresApproval: false,
  handler: async (args, ctx) => {
    const path = typeof args.path === 'string' ? args.path : '';
    if (!path) return { error: 'path required' };
    const note = await ctx.openVaultNote(path);
    if (!note) return { error: `Note "${path}" not found` };
    return note;
  },
};
